import { computed as V, readonly as T, defineComponent as N, createElementBlock as p, createCommentVNode as M, openBlock as d, normalizeStyle as S, unref as v, createElementVNode as i, toDisplayString as g, createBlock as z, withCtx as w, Fragment as C, renderList as $, normalizeClass as L, createVNode as A } from "vue";
import { FloatingMenu as B } from "ui-components";
function D() {
  return crypto.randomUUID();
}
function vt({
  phases: f,
  specificationsState: e,
  variants: a,
  onSpecificationClick: c
}) {
  function l(s) {
    var n;
    const o = a.value.find((t) => t.id === s.mainVariantId), b = f.value.find((t) => t.id === s.phaseId);
    return !o || !b ? null : {
      id: s.id,
      mainVariant: o,
      phase: b,
      variants: ((n = s.variantIds) == null ? void 0 : n.map((t) => a.value.find((I) => I.id === t)).filter((t) => t !== void 0)) ?? []
    };
  }
  const r = V(() => e.value.map((s) => l(s)).filter((s) => s !== null));
  function m(s) {
    const o = e.value.findIndex(
      (b) => b.id === s.id
    );
    o !== -1 && e.value.splice(o, 1);
  }
  function k({
    variant: s,
    phase: o
  }) {
    e.value.push({
      id: D(),
      mainVariantId: s.id,
      phaseId: o.id,
      variantIds: []
    });
  }
  function _({
    variant: s,
    sourceSpec: o
  }) {
    o && e.value.push({
      id: D(),
      phaseId: o == null ? void 0 : o.phase.id,
      mainVariantId: s.id,
      variantIds: []
    });
  }
  function y({
    sourceSpec: s,
    variant: o
  }) {
    const b = e.value.findIndex(
      (t) => t.id === s.id
    );
    if (b === -1) return;
    const n = e.value[b];
    n.variantIds || (n.variantIds = []), n.variantIds.push(o.id);
  }
  function x({
    sourceSpec: s,
    variant: o
  }) {
    const b = e.value.findIndex(
      (t) => t.id === s.id
    );
    if (b === -1) return;
    const n = e.value[b];
    n.variantIds || (n.variantIds = []), n.variantIds = n.variantIds.filter((t) => t !== o.id);
  }
  return {
    variants: T(a),
    phases: T(f),
    specifications: r,
    deleteSpecification: m,
    copyFromSpecification: _,
    linkToSpecification: y,
    unlinkFromSpecification: x,
    createSpecification: k,
    onSpecificationClick: c
  };
}
function P(f, e = 20) {
  const { h: a, s: c, l } = U(f);
  return j(a, c, Math.max(l - e, 10));
}
function q(f, e = 30) {
  const { h: a, s: c, l } = U(f);
  return j(a, Math.max(c - 20, 20), Math.min(l + e, 90));
}
function U(f) {
  const e = parseInt(f.slice(1, 3), 16) / 255, a = parseInt(f.slice(3, 5), 16) / 255, c = parseInt(f.slice(5, 7), 16) / 255, l = Math.max(e, a, c), r = Math.min(e, a, c);
  let m, k;
  const _ = (l + r) / 2;
  if (l === r)
    m = k = 0;
  else {
    const y = l - r;
    switch (k = _ > 0.5 ? y / (2 - l - r) : y / (l + r), l) {
      case e:
        m = (a - c) / y + (a < c ? 6 : 0);
        break;
      case a:
        m = (c - e) / y + 2;
        break;
      case c:
        m = (e - a) / y + 4;
        break;
      default:
        m = 0;
    }
    m /= 6;
  }
  return {
    h: Math.round(m * 360),
    s: Math.round(k * 100),
    l: Math.round(_ * 100)
  };
}
function j(f, e, a) {
  a /= 100;
  const c = e * Math.min(a, 1 - a) / 100, l = (r) => {
    const m = (r + f / 30) % 12, k = a - c * Math.max(Math.min(m - 3, 9 - m, 1), -1);
    return Math.round(255 * k).toString(16).padStart(2, "0");
  };
  return `#${l(0)}${l(8)}${l(4)}`;
}
const G = {
  key: 0,
  class: "flex items-center justify-between w-full pr-3 pl-1"
}, J = { class: "flex items-center gap-1 truncate" }, K = {
  key: 0,
  class: "flex items-center gap-1 truncate"
}, O = { class: "truncate" }, Q = { class: "flex items-center bg-neutral-50 rounded-lg px-1 py-0.5 text-black ml-0.5" }, R = {
  key: 1,
  class: "justify-center items-center flex w-full h-full gap-1"
}, W = ["onClick"], X = { class: "flex flex-col divide-y divide-mid-neutral-50 bg-white min-w-[180px]" }, Y = ["onClick"], Z = { class: "truncate text-black" }, tt = ["onClick"], et = { class: "flex flex-col divide-y divide-mid-neutral-50 bg-white min-w-[180px]" }, nt = ["onClick"], it = { class: "truncate text-black" }, at = /* @__PURE__ */ N({
  __name: "Specification",
  props: {
    phase: {},
    variant: {},
    composable: {}
  },
  setup(f) {
    const e = f, {
      variants: a,
      specifications: c,
      deleteSpecification: l,
      createSpecification: r,
      copyFromSpecification: m,
      linkToSpecification: k,
      unlinkFromSpecification: _,
      onSpecificationClick: y
    } = e.composable, x = V(() => c.value.find(
      (n) => (n.mainVariant.id === e.variant.id || n.variants.some((t) => t.id === e.variant.id)) && n.phase.id === e.phase.id
    ) ?? null), s = V(() => {
      var n;
      return ((n = x.value) == null ? void 0 : n.mainVariant.color) ?? e.variant.color ?? "#000000";
    }), o = V(
      () => c.value.filter(
        (n) => n.phase.id === e.phase.id && n.mainVariant.id !== e.variant.id
      )
    );
    function b(n) {
      var t;
      return ((t = a.value.find((I) => I.id === n.mainVariant.id)) == null ? void 0 : t.color) || "#000000";
    }
    return (n, t) => {
      var I, F, E;
      return n.phase.isEnabled ? (d(), p("div", {
        key: 0,
        class: "w-full h-full flex items-center",
        style: S(
          x.value && {
            backgroundColor: v(q)(s.value),
            color: v(P)(s.value)
          }
        )
      }, [
        x.value ? (d(), p("div", G, [
          i("div", J, [
            n.variant.id !== ((I = x.value) == null ? void 0 : I.mainVariant.id) ? (d(), p("div", K, [
              i("button", {
                onClick: t[0] || (t[0] = (h) => {
                  var u;
                  return (u = v(y)) == null ? void 0 : u(x.value);
                }),
                class: "px-2 flex items-center"
              }, t[5] || (t[5] = [
                i("span", { class: "material-symbols-outlined" }, " link ", -1)
              ])),
              i("div", O, g((F = x.value) == null ? void 0 : F.mainVariant.name), 1)
            ])) : (d(), p("button", {
              key: 1,
              onClick: t[1] || (t[1] = (h) => {
                var u;
                return (u = v(y)) == null ? void 0 : u(x.value);
              }),
              class: "px-2 flex items-center"
            }, t[6] || (t[6] = [
              i("span", { class: "material-symbols-outlined" }, " edit_document ", -1)
            ])))
          ]),
          i("div", Q, [
            n.variant.id === ((E = x.value) == null ? void 0 : E.mainVariant.id) ? (d(), p("button", {
              key: 0,
              class: "flex items-center px-1",
              onClick: t[2] || (t[2] = (h) => v(l)(x.value)),
              title: "Delete"
            }, t[7] || (t[7] = [
              i("span", { class: "material-symbols-outlined" }, "delete", -1)
            ]))) : (d(), p("button", {
              key: 1,
              class: "flex items-center px-1",
              onClick: t[3] || (t[3] = (h) => v(_)({
                sourceSpec: x.value,
                variant: n.variant
              })),
              title: "Unlink"
            }, t[8] || (t[8] = [
              i("span", { class: "material-symbols-outlined" }, "link_off", -1)
            ])))
          ])
        ])) : (d(), p("div", R, [
          i("button", {
            class: "flex items-center px-2 h-full",
            onClick: t[4] || (t[4] = (h) => v(r)({
              phase: n.phase,
              variant: n.variant
            })),
            title: "Add"
          }, t[9] || (t[9] = [
            i("span", { class: "material-symbols-outlined" }, "add", -1)
          ])),
          o.value.length ? (d(), z(v(B), {
            key: 0,
            placement: "bottom-start",
            flip: !1
          }, {
            activator: w(({ show: h }) => [
              i("button", {
                title: "Copy",
                class: "flex items-center px-2 h-full",
                onClick: (u) => h()
              }, t[10] || (t[10] = [
                i("span", { class: "material-symbols-outlined" }, "content_copy", -1)
              ]), 8, W)
            ]),
            content: w(({ hide: h }) => [
              i("div", X, [
                (d(!0), p(C, null, $(o.value, (u) => (d(), p("button", {
                  key: u.id + "-copy",
                  class: "text-left px-3 py-2 hover:bg-gray-50 flex items-center gap-2",
                  onClick: (H) => {
                    v(m)({ variant: n.variant, sourceSpec: u }), h();
                  }
                }, [
                  i("span", {
                    class: "w-3 h-3 rounded-full",
                    style: S({ backgroundColor: b(u) })
                  }, null, 4),
                  i("span", Z, g(u.mainVariant.name) + " - " + g(u.phase.name), 1)
                ], 8, Y))), 128))
              ])
            ]),
            _: 1
          })) : M("", !0),
          o.value.length ? (d(), z(v(B), {
            key: 1,
            placement: "bottom-start",
            flip: !1
          }, {
            activator: w(({ show: h }) => [
              i("button", {
                title: "Link",
                class: "flex items-center px-2 h-full",
                onClick: (u) => h()
              }, t[11] || (t[11] = [
                i("span", { class: "material-symbols-outlined" }, "add_link", -1)
              ]), 8, tt)
            ]),
            content: w(({ hide: h }) => [
              i("div", et, [
                (d(!0), p(C, null, $(o.value, (u) => (d(), p("button", {
                  key: u.id + "-link",
                  class: "text-left px-3 py-2 hover:bg-gray-50 flex items-center gap-2",
                  onClick: (H) => {
                    v(k)({ variant: n.variant, sourceSpec: u }), h();
                  }
                }, [
                  i("span", {
                    class: "w-3 h-3 rounded-full",
                    style: S({ backgroundColor: b(u) })
                  }, null, 4),
                  i("span", it, g(u.mainVariant.name) + " - " + g(u.phase.name), 1)
                ], 8, nt))), 128))
              ])
            ]),
            _: 1
          })) : M("", !0)
        ]))
      ], 4)) : M("", !0);
    };
  }
}), lt = { class: "px-6 py-4 overflow-hidden flex" }, st = { class: "overflow-auto" }, ot = { class: "min-w-max table-fixed bg-white text-left border-collapse" }, rt = { class: "bg-gray-100 text-sm text-mid-neutral-500" }, dt = { class: "text-dark-neutral-500" }, ct = { class: "px-7.5 py-3.5 sticky left-0 bg-white" }, ut = { class: "flex gap-2.5 items-center" }, mt = { class: "material-symbols-outlined" }, bt = /* @__PURE__ */ N({
  __name: "Specifications",
  props: {
    composable: {}
  },
  setup(f) {
    const { variants: e, phases: a } = f.composable;
    return (c, l) => (d(), p("div", lt, [
      i("div", st, [
        i("table", ot, [
          i("thead", rt, [
            i("tr", null, [
              l[0] || (l[0] = i("th", { class: "py-4 px-7.5 border-b border-mid-neutral-50 sticky left-0 top-0 bg-gray-100 z-10" }, " Phases ", -1)),
              (d(!0), p(C, null, $(v(e), (r, m) => (d(), p("th", {
                key: r.id,
                class: "py-4 px-7.5 border-b border-mid-neutral-50 text-center min-w-50 sticky top-0 bg-gray-100"
              }, g(r.name || `Variant ${m + 1}`), 1))), 128))
            ])
          ]),
          i("tbody", dt, [
            (d(!0), p(C, null, $(v(a), (r, m) => (d(), p("tr", {
              key: m,
              class: L(["hover:bg-gray-50 transition border-b border-mid-neutral-50", {
                "bg-light-neutral-200 text-dark-neutral-100": !r.isEnabled
              }])
            }, [
              i("td", ct, [
                i("div", ut, [
                  i("span", mt, g(r.icon), 1),
                  i("span", null, g(r.name), 1)
                ])
              ]),
              (d(!0), p(C, null, $(v(e), (k) => (d(), p("td", {
                key: `${r.id}-${k.id}`,
                class: "border-l border-mid-neutral-50 text-center p-0 h-0"
              }, [
                A(at, {
                  variant: k,
                  phase: r,
                  composable: c.composable
                }, null, 8, ["variant", "phase", "composable"])
              ]))), 128))
            ], 2))), 128))
          ])
        ])
      ])
    ]));
  }
});
export {
  bt as Specifications,
  vt as useSpecifications
};
//# sourceMappingURL=index.js.map
